<template>
    <el-table
        :data="checklistType"
        :show-header="false"
        row-key="id"
        @row-click="expandRow"
        :expand-row-keys="expand"
        cell-class-name="checklist-cell"
        empty-text="No Checklist answered yet"
        style="width: 100%">
        <el-table-column prop="title">
            <template slot-scope="scope">
                <div style="padding-left: 16px;">
                    <span class="checklist-title">
                        {{ getContentKey('checklist', scope.row.id.split(':')[0], 'title') }}
                        <span class="checklist-provider" v-if="allPatientsChosen">
                            {{ getProviderNameById(scope.row.id.split(':')[1]) }}
                            {{ getProfileFromProvider(scope.row.id.split(':')[1], patient)  }}
                        </span>
                        
                    </span>
                    <small v-if="scope.row.event.length > 0">
						Sent {{ scope.row.event.length }} times, next due on {{ nextDue(scope.row) }}
					</small>
                    <small v-else>
						Not yet sent
					</small>
                </div>
            </template>
        </el-table-column>
        <el-table-column type="expand" width="55px">
            <template slot-scope="scope">
                <ChecklistAnalysis
                    :checklists="scope.row.event"
                    :id="scope.row.id">
                </ChecklistAnalysis>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import CardTable from '../component/table'

import ChecklistAnalysis from './analysis/Analysis'

export default {
    name: 'patient-checklist-card-table',
    extends: CardTable,

    props: {
        checklists: {
            type: Array
        },
        patient: {
            type: Object,
            required: true
        }
    },

    methods: {
        nextDue(rowData) {
            if(rowData.event.length > 0)
                return this.formatDate(rowData.event[0].time)
        }
    },

    computed: {
        checklistType() {
            try {
                let type = {}
                this.checklists.forEach(checklist => {
                    let t = checklist.type.split(':')[1] + ':' + checklist.provider
                    if(! type[t])
                        type[t] = {
                            id: t,
                            event: []
                        }
                    type[t].event.push(checklist)
                })
                return Object.keys(type).map((t) => {
                    type[t].event.sort((a, b) => (b.time - a.time))
                    type[t].active = type[t].event.filter((a) => (a.time + 86400000 > Date.now()))
                    if (type[t].active.length > 0)
                        type[t].last = type[t].active[type[t].active.length - 1]
                    return type[t]
                })
            } catch (error) {
                console.error(error)
                return []
            }
        }
    },

    components: {
        ChecklistAnalysis
    }
}
</script>

<style lang="scss">
@import "@/module/app/theme/color.scss";

.checklist-title{
    display: block;
    font-weight: bold;
    line-height: normal;
}
.checklist-provider {
    padding-left: 12px;
    display: inline;
    align-items: center;
    color: $grey-700;
    font-weight: normal;
	&::before {
		content: "\A";
		width: 3px;
		height: 3px;
		border-radius: 50%;
		background-color: $black-color;
		display: inline-block;
        margin-right: 12px;
        margin-bottom: 3px;
	}
}
.checklist-cell {
	cursor: pointer;
	.el-table__expand-icon {
		transform: rotate(90deg);
		height: 24px;
		width: 24px;
		border-radius: 50%;
		border: 1px solid #cccccc;
        color: #666666;
        .el-icon {
            font-weight: bold;
            margin-left: -6px;
        }
	}
	.el-table__expand-icon--expanded {
		transform: rotate(-90deg);
		background-color: #c45531;
        color: #ffffff;
        border: 1px transparent;
	}
	
}
</style>
